<template>
  <div>
    <main class="main-content">
      <div class="page-content">
        <div class="container">
          <div class="lds-ring" v-if="!isLoad">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </div>
          <section class="story-templates" v-if="isLoad">
            <div class="page-title">
              <h2>Make a Story | My Templates</h2>
              <div class="page-title__side">
                <div class="form-control-wrap">
                  <input
                    type="text"
                    placeholder="Search"
                    v-model="search"
                    class="form-control-search" />
                  <div class="form-control-icon">
                    <svg width="1em" height="1em" class="icon icon-search">
                      <use
                        xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-search"></use>
                    </svg>
                  </div>
                </div>
                <router-link
                  to="/new"
                  class="btn btn--green"
                  :style="{marginLeft: '0px'}">
                  <span>New Program</span></router-link
                >
              </div>
            </div>
            <simplebar
              data-simplebar-auto-hide="true"
              class="story-templates__table-wrap templates-wrapper"
              :style="{paddingBottom: '160px', p}">
              <div class="story-templates__table">
                <div class="story-templates__table__head">
                  <div class="col col-clients-name">
                    <span>Group Name</span>
                  </div>
                  <div class="col col-duration"><span>Duration</span></div>
                  <div class="col col-created"><span>Created</span></div>
                  <div class="col col-last-update">
                    <span>Last Update</span>
                  </div>
                  <div class="col col-pax"><span>Pax</span></div>
                </div>
                <div
                  class="story-templates__table__row"
                  v-for="item in templates.slice(
                    (page - 1) * 15,
                    (page - 1) * 15 + 15
                  )"
                  :key="item.id">
                  <div class="col col-clients-name">
                    <div v-if="item.isPrioritized" class="prioritized">
                      <svg width="1em" height="1em" class="icon icon-fire">
                        <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-fire" />
                      </svg>
                    </div>

                    <a :href="`/templates/${item.id}`">{{ item.groupName }}</a>
                  </div>
                  <div class="col col-duration">
                    <span>{{ item.duration }} days</span>
                  </div>
                  <div class="col col-created">
                    <span>{{ item.createdAt }}</span>
                  </div>
                  <div class="col col-last-update">
                    <span>{{ item.updatedAt }}</span>
                  </div>
                  <div class="col col-pax">
                    <span>Total Pax: {{ item.totalPax }}</span>
                  </div>
                  <div class="col col-icons-2">
                    <img
                      v-if="item.programTypes.includes('CLIMBING')"
                      src="/images/useful/svg/clients-icon1.svg"
                      alt="" />
                    <img
                      v-if="item.programTypes.includes('SAFARI')"
                      src="/images/useful/svg/clients-icon2.svg"
                      alt="" />
                    <img
                      v-if="item.programTypes.includes('ISLAND')"
                      src="/images/useful/svg/clients-icon3.svg"
                      alt="" />
                  </div>
                  <div class="col col-action">
                    <button
                      type="button"
                      class="story-templates__table__dropdown-trigger"
                      @click="openMenu(item.id)">
                      <svg width="1em" height="1em" class="icon icon-more">
                        <use
                          xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-more"></use>
                      </svg>
                      <div class="edit-popup edit-popup--short" v-if="item.menu">
                        <div class="form-control-group">
                          <button
                              type="button"
                              class="btn form-control-action"
                              @click.stop="$router.push('/templates/' + item.id)">
                            <span class="form-control-action__icon icon--green">
                              <svg
                                  width="1em"
                                  height="1em"
                                  class="icon icon-edit">
                                <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-edit" />
                              </svg>
                            </span>
                            <span class="form-control-action__text">Open</span>
                          </button>
                        </div>
                        <div class="form-control-group" v-if="user && user.id === item.createdByUserId">
                          <button
                              type="button"
                              class="btn form-control-action"
                              @click.stop="copyTemplateHandler(item.id)">
                            <span
                                class="form-control-action__icon icon--orange">
                              <svg
                                  width="1em"
                                  height="1em"
                                  class="icon icon-copy">
                                <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-copy" />
                              </svg>
                            </span>
                            <span class="form-control-action__text">Copy</span>
                          </button>
                        </div>
                        <div class="form-control-group" v-if="user && user.id === item.createdByUserId">
                          <button
                              type="button"
                              class="btn form-control-action"
                              @click.stop="
                              $emit('deleteModalHandler', {
                                entity: 'Template',
                                name: 'this',
                                handler: deleteTemplateHandler,
                                id: item.id,
                              })
                            ">
                            <span class="form-control-action__icon icon--red">
                              <svg
                                  width="1em"
                                  height="1em"
                                  class="icon icon-close">
                                <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-close" />
                              </svg>
                            </span>
                            <span class="form-control-action__text">Delete</span>
                          </button>
                        </div>
                      </div>
                    </button>
                  </div>
                </div>
              </div>
            </simplebar>
            <Pagination
              :page="page"
              :pageCount="pageCount"
              @pageController="pageController" />
          </section>
        </div>
      </div>
    </main>
    <div class="modal-wrapper" v-if="link">
      <div class="modal-backdrop"></div>
      <div class="modal-inner">
        <div class="edit-popup edit-popup--copy-link">
          <div class="edit-popup__header">
            <div class="edit-popup__title">
              <div class="edit-popup__title__icon" @click="link = false">
                <svg width="1em" height="1em" class="icon icon-link">
                  <use
                    xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-link"></use>
                </svg>
              </div>
              <span>The program link</span>
            </div>
          </div>
          <div class="edit-popup__text">
            <p>
              Вы можете отправить ссылку на программу участникам своей
              делигации.
            </p>
          </div>
          <form action="javascript:void(0)" class="edit-popup--copy-link__form">
            <div class="form-control-group">
              <div class="form-control-wrap">
                <input
                  type="text"
                  :value="linkTemplate"
                  class="form-control"
                  readonly />
              </div>
            </div>
            <button
              type="submit"
              class="btn copylink-btn btn--green"
              :data-clipboard-text="linkTemplate">
              <span>Copy</span>
            </button>
          </form>
        </div>
      </div>
    </div>
    <div class="modal-wrapper" v-if="share">
      <div class="modal-backdrop"></div>
      <div class="modal-inner">
        <div class="edit-popup edit-popup--share">
          <div class="edit-popup__header">
            <div class="edit-popup__title">
              <div class="edit-popup__title__icon">
                <svg width="1em" height="1em" class="icon icon-letter">
                  <use
                    xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-letter"></use>
                </svg>
              </div>
              <span>Share the program</span>
            </div>
            <div class="edit-popup__close" @click="share = false">
              <svg width="1em" height="1em" class="icon icon-close">
                <use
                  xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-close"></use>
              </svg>
            </div>
          </div>
          <form action="javascript:void(0)" class="edit-popup--share__form">
            <div class="form-control-group">
              <span class="form-control-label">Select Managers</span>
              <div
                :class="[
                  'select-wrapper select-wrapper--managers',
                  {'is-active': usersSelect},
                ]"
                @click="usersSelect = !usersSelect">
                <div class="select-trigger">
                  <div class="select-trigger__name">
                    <div
                      class="select-trigger__manager"
                      v-for="user in users.filter((item) => item.active)"
                      :key="user.id">
                      <div class="select-option__image h-object-fit">
                        <img
                          :src="`${API}/documents/share/images/${user.photo}?size=SMALL`"
                          alt="kiril" />
                      </div>
                      <span>{{ user.firstName }},</span>
                    </div>
                  </div>
                  <span class="select-trigger__icon">
                    <svg width="1em" height="1em" class="icon icon-chevron">
                      <use
                        xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-chevron"></use></svg
                  ></span>
                </div>
                <div class="select-body">
                  <div class="select-inner js-scrollbar">
                    <div
                      class="select-option"
                      v-for="user in users"
                      :key="user.id">
                      <label
                        class="form-control-checkbox"
                        @click.stop="user.active = !user.active">
                        <input
                          type="checkbox"
                          :checked="user.active"
                          @click.prevent.stop /><span
                          class="form-control-checkbox__box">
                          <svg width="1em" height="1em" class="icon icon-check">
                            <use
                              xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-check"></use></svg></span
                        ><span class="select-option__image h-object-fit"
                          ><img
                            :src="`${API}/documents/share/images/${user.photo}?size=SMALL`"
                            alt="kiril" /></span
                        ><span class="select-option__name">{{
                          user.firstName
                        }}</span>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <button
              type="submit"
              class="btn btn--green"
              @click="shareTemplateHandler">
              <span>Share program</span>
            </button>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getTemplates,
  deleteTemplate,
  getUsers,
  shareTemplate,
  copyTemplate,
  API,
} from '@/utilites/api'

import Pagination from '@/components/Pagination.vue'

import simplebar from 'simplebar-vue'

import ClipboardJS from 'clipboard'

export default {
  components: {Pagination, simplebar, ClipboardJS},
  data() {
    return {
      API: API,
      templates: [],
      templatesData: [],
      page: 1,
      pageCount: 0,
      search: '',
      link: false,
      share: false,
      usersSelect: false,
      edit: {},
      users: [],
      isLoad: false,
    }
  },
  props: ['user'],
  beforeCreate() {
    document.title = 'My Templates'
  },
  mounted() {
    this.updateData()
    getUsers(this.user.access_token).then((res) => {
      this.users = res.map((item) => ({...item, active: false}))
    })
    this.pageCountHandler()
    document.title = 'My Templates'
    window.addEventListener('click', (event) => {
      if (!event.target.closest('.story-templates__table__dropdown-trigger')) {
        this.templates = this.templates.map((item) => ({...item, menu: false}))
      }
      if (
        !event.target.closest('.edit-popup') &&
        !event.target.closest('.btn')
      ) {
        this.link = false
        this.share = false
      }
    })
    let clip = new ClipboardJS('.copylink-btn')
    clip.on('success', () => {
      this.link = false
    })
  },
  methods: {
    pageController(page) {
      this.page = page
    },
    pageCountHandler() {
      this.pageCount = Math.ceil(this.templates.length / 15)
    },
    openMenu(id) {
      this.templates = this.templates.map((item) =>
        item.id === id ? {...item, menu: !item.menu} : {...item, menu: false}
      )
    },
    updateData() {
      this.isLoad = true
      getTemplates(this.user.access_token, this.user.id).then((res) => {
        this.isLoad = true
        this.templates = res.map((item) => ({...item, menu: false}))
        this.templatesData = res.map((item) => ({...item, menu: false}))
      })
    },
    deleteTemplateHandler(id) {
      deleteTemplate(this.user.access_token, id).then(() => this.updateData())
    },
    shareTemplateHandler() {
      shareTemplate(
        this.user.access_token,
        this.edit.id,
        this.user.id,
        this.users.filter((item) => item.active).map((item) => item.id)
      ).then((res) => {
        this.share = false
      })
    },
    copyTemplateHandler(id) {
      copyTemplate(this.user.access_token, id, this.user.id).then(() =>
        this.updateData()
      )
    },
  },
  watch: {
    templates() {
      this.pageCountHandler()
    },
    search() {
      if (this.search.length === 0) {
        this.templates = this.templatesData
      }
      this.page = 1
      let filtered = this.templatesData.filter((item) =>
        this.search.length
          ? item.groupName &&
            item.groupName.toLowerCase().includes(this.search.toLowerCase())
            ? item
            : false
          : item
      )
      this.templates = filtered
      this.pageCount = Math.ceil(filtered.length / 15)
    },
    link() {
      if (!this.link) {
        this.edit = false
      } else {
        this.templates = this.templates.map((item) => ({...item, menu: false}))
      }
      window.addEventListener('click', (event) => {
        if (!event.target.closest('.edit-popup')) {
          this.link = false
        }
      })
    },
    share() {
      if (!this.share) {
        this.edit = false
      } else {
        this.templates = this.templates.map((item) => ({...item, menu: false}))
      }
    },
  },
  computed: {
    linkTemplate() {
      return window.location.origin + '/templates/' + this.edit.id
    },
  },
}
</script>

<style lang="scss" scoped>
.templates-wrapper {
  margin-left: -40px;
  padding-left: 40px;

  .prioritized {
    left: 1.5rem;
    position: absolute;
  }
}

.story-templates__table{
  .col-clients-name {
    a {
      font-weight: 400;
      font-size: 12px;
      line-height: 17px;

      color: #000000;

      text-decoration: none;
      padding-top: 6px;
      padding-bottom: 3px;

      transition: .3s;
      border-bottom: 3px solid transparent;

      &:hover {
        border-bottom: 3px solid #AAE182;
      }

    }
  }

  .story-templates__table__row {
    height: auto;
    padding: 0.5rem 1.4rem;
  }
}
</style>
